import { MeetingRoomResponse } from "../../model/meetingRoomResponse";
import { asSelectOptions, SelectOptionsType } from "../../utils/select-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = MeetingRoomResponse;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getMeetingRooms(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(
      apiUrls.getMeetingRooms
    );
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = asSelectOptions({ data: response.data });
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error fetching Meeting Rooms:", err);
    return { error: (err as Error).message };
  }
}
